
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stock-list",
      function () {
        return require("private-next-pages/stock-list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stock-list"])
      });
    }
  